import request from '@/router/axios';

function toBladePageParams(params) {
  const p = { ...params };
  if (p.page != null) {
    p.current = p.page;
    delete p.page;
  }
  return p;
}

export const getList = (params) => {
  return request({
    url: '/api/produce/base-own-vehicle/page',
    method: 'get',
    params: toBladePageParams(params),
  });
};

export const exportExcel = (params) => {
  return request({
    url: '/api/produce/base-own-vehicle/export',
    method: 'get',
    params: toBladePageParams(params),
    responseType: 'blob',
  });
};

export const importExcel = (data) => {
  return request({
    url: '/api/produce/base-own-vehicle/import-excel',
    method: 'post',
    data,
  });
};

export const downloadTemplate = () => {
  return request({
    url: '/api/produce/base-own-vehicle/import-template',
    method: 'get',
    responseType: 'blob',
  });
};

export const getDetail = (id) => {
  return request({
    url: '/api/produce/base-own-vehicle/detail',
    method: 'get',
    params: { id },
  });
};

export const add = (row) => {
  return request({
    url: '/api/produce/base-own-vehicle/save',
    method: 'post',
    data: row,
  });
};

export const update = (row) => {
  return request({
    url: '/api/produce/base-own-vehicle/update',
    method: 'post',
    data: row,
  });
};

export const remove = (id) => {
  return request({
    url: '/api/produce/base-own-vehicle/remove',
    method: 'post',
    params: { ids: id },
  });
};
